'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidArrowDroprightCircle = function IoAndroidArrowDroprightCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 36.3c-9 0-16.3-7.3-16.3-16.3s7.3-16.2 16.3-16.2 16.2 7.2 16.2 16.2-7.3 16.3-16.2 16.3z m-2.5-8.8l7.5-7.5-7.5-7.5v15z' })
        )
    );
};

exports.default = IoAndroidArrowDroprightCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-arrow-dropright-circle.js
// module id = 2048
// module chunks = 0